import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    redirect: '/presale',
  },

  /** 小订 start */
  {
    path: '/presale',
    name: 'PreSale',
    component: () => import(/* webpackChunkName: "presale" */ '../views/presale/Index.vue'),
    meta: {
      title: '预订爱车',
    },
  },
  {
    path: '/presale/rights',
    name: 'rights',
    component: () => import(/* webpackChunkName: "rights" */ '../views/presale/Rights.vue'),
    meta: {
      title: '十大权益详情',
    },
  },
  {
    path: '/presale/unsubscribe',
    name: 'unsubscribeApply',
    component: () => import(/* webpackChunkName: "unsubscribeApply" */ '../views/presale/UnsubscribeApply.vue'),
    meta: {
      title: '申请退订',
    },
  },
  {
    path: '/presale/payment',
    name: 'payment',
    component: () => import(/* webpackChunkName: "payment" */ '../views/payment.vue'),
    meta: {
      title: '意向金协议',
    },
  },
  {
    path: '/presale/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: {
      title: '隐私协议',
    },
  },
  {
    path: '/presale/orderDetail',
    name: 'OrderDetail',
    component: () => import(/* webpackChunkName: "orderDetail" */ '../views/presale/OrderDetail.vue'),
    meta: {
      title: '预订详情',
    },
  },
  {
    path: '/presale/infoTip',
    name: 'InfoTip',
    component: () => import(/* webpackChunkName: "infoTip" */ '../views/presale/InfoTip.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/presale/GongZheng',
    name: 'GongZheng',
    component: () => import(/* webpackChunkName: "gongZheng" */ '../views/presale/GongZheng.vue'),
    meta: {
      title: '公证说明',
    },
  },
  {
    path: '/presale/YuShou',
    name: 'YuShou',
    component: () => import(/* webpackChunkName: "yuShou" */ '../views/presale/YuShou.vue'),
    meta: {
      title: '认购须知',
    },
  },
  /** 小订 end */

  /** 大定 start */
  {
    path: '/book',
    name: 'optional',
    component: () => import(/* webpackChunkName: "optional" */ '../views/book/optional/Optional.vue'),
    meta: {
      title: '预定爱车',
    },
  },
  {
    path: '/book/orderFill',
    name: 'orderFill',
    component: () => import(/* webpackChunkName: "orderFill" */ '../views/book/orderFill/OrderFill.vue'),
    meta: {
      title: '填写预定信息',
    },
  },
  // {
  //   path: '/presale/orderListOld',
  //   name: 'orderList',
  //   component: () => import(/* webpackChunkName: "orderList" */ '../views/presale/orderList/OrderList.vue'),
  //   meta: {
  //     title: '我的订单',
  //   },
  // },
  {
    path: '/presale/orderList',
    name: 'bookList',
    component: () => import(/* webpackChunkName: "bookList" */ '../views/book/bookList/BookList.vue'),
    meta: {
      title: '我的订单',
    },
  },
  {
    path: '/book/orderDetail',
    name: 'bookDetail',
    component: () => import(/* webpackChunkName: "bookDetail" */ '../views/book/bookDetail/BookDetail.vue'),
    meta: {
      title: '订单详情',
    },
  },

  {
    path: '/book/signResult',
    name: 'signResult',
    component: () => import(/* webpackChunkName: "signResult" */ '../views/book/pay/SignResult.vue'),
    meta: {
      title: '协议签署',
    },
  },
  {
    path: '/book/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "pay" */ '../views/book/pay/CashPay.vue'),
    meta: {
      title: '收银台',
    },
  },

  {
    path: '/calculator',
    name: 'calculator',
    component: () => import(/* webpackChunkName: "calculator" */ '../views/book/calculator/Calculator.vue'),
    meta: {
      title: '金融试算',
    },
  },
  /** 大定 end */
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 从客户端获取用户信息
  if (!store.state.userInfo.loaded) {
    store.dispatch('getUserInfo').then(() => {
      next()
    })
  } else {
    next()
  }
})
export default router
